import CarouselSlider from './carousel-slider'
import loadDaySchedule from './loadDaySchedule'
import moment from 'moment'

export default () => {
	CarouselSlider.init('.carousel--branding', {
		effect: 'fade',
		loop: true,
	})

	CarouselSlider.init('.carousel--promo', {
		autoHeight: true,
		allowTouchMove: false,
		on: {
			init: (swiper) => {
				var sclVis = document.querySelector('.carousel__item .scale-visual').clientHeight;
				document.querySelector('.carousel__pagination.swiper-pagination').style.top = (sclVis - 44) + "px";
			},
			slideChange: (swiper) => {
				const prevSlide = swiper.slides[swiper.previousIndex]
				const iframe = prevSlide.querySelector('iframe')
				const video = prevSlide.querySelector('video')

				if (iframe) {
					const src = iframe.src
					iframe.src = src
				}
				if (video) {
					video.pause()
				}

			},
			slideChangeTransitionEnd: (swiper) => {
				var sclVis = document.querySelector('.carousel__item .scale-visual').clientHeight;
				document.querySelector('.carousel__pagination.swiper-pagination').style.top = (sclVis - 44) + "px";
			}
		},
	})

	CarouselSlider.init('.carousel--program-list', {
		slidesPerView: 3,
		spaceBetween: 20,
		// autoHeight: true,
		breakpoints: {
			320: { slidesPerView: 1 },
			560: { slidesPerView: 2 },
			767: { slidesPerView: 3 },
		},
		on: {
			init: function (e) {
				// preloading
				var showbox = document.querySelector('.showbox')
				var slider = document.querySelector('.carousel--program-list')
				showbox.style.display = 'none';
				slider.classList.remove("v-hidden", "h-0");
			},
		},
	})

	if (document.querySelector('#calendarSlider')) {
		const calendarSlider = document.querySelector('#calendarSlider')
		const list = calendarSlider.querySelectorAll('li')

		list.forEach((el, key) => {
			if (el.dataset.date === moment().subtract('5', 'hour').format('YYYY-MM-DD')) {
				el.classList.add('active')
			}

			el.addEventListener('click', function () {
                let selection = document.querySelector('#calendarSlider li.active') !== null;
                if (selection) {
                    document.querySelector('#calendarSlider li.active').classList.remove('active')
                    el.classList.add('active')

                    const date = el.dataset.date

                    loadDaySchedule(date)
                } else {
                    el.classList.add('active')

                    const date = el.dataset.date

                    loadDaySchedule(date)
                }
			})
		})
	}

	window.addEventListener('load', () => {
		$('.news-list').sliceHeight({
			el: 'li .title',
			slice: 3,
		})

		$('.slider-box ul').carouFredSel({
			circular: false,
			infinite: true,
			auto: false,
			responsive: false,
			scroll: {
				duration: 600,
			},
			pagination: '.slider-box .page',
		})

		$('.tvshow .calendar ul').carouFredSel({
			width: '100%',
			circular: false,
			infinite: true,
			auto: false,
			responsive: true,
			prev: {
				button: '.tvshow .calendar .arr-l',
			},
			next: {
				button: '.tvshow .calendar .arr-r',
			},
			items: {
				start: 7,
				visible: { min: 1, max: 7 },
			},
			scroll: {
				items: 1,
				duration: 400,
			},
		})

		$('.tvshow .list .title').on('click', function () {
			if ($(this).siblings('.inform').html() != undefined) {
				if ($(this).siblings('.inform').css('display') == 'none') {
					$(this).siblings('.inform').css('display', 'block')
					$(this).parent('li').addClass('active')
				} else {
					$(this).siblings('.inform').css('display', 'none')
					$(this).parent('li').removeClass('active')
				}
			}
		})
	})
}
